export default {
  allGroups: null,
};
